module.exports = __webpack_public_path__ + "media/images/emblems/Amlikon_Bissegg_Blazono-dacb51a715076f82a9c57bf631f79163.png";